import { Badge } from '@ui';

/** Marks Outlook as a beta provider wherever it is offered or listed. */
export function OutlookBetaBadge() {
  return (
    <Badge variant="outline" size="xs">
      Beta
    </Badge>
  );
}
